import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/utils/cn';

const LINKS = [
  { to: '/groups', end: true, key: 'nav.manual' },
  { to: '/groups/auto-filled', end: false, key: 'nav.autoFilled' },
] as const;

export const GroupsSubnav = () => {
  const { t } = useTranslation('groups');

  return (
    <nav className="mb-6 flex flex-wrap gap-2" aria-label={t('title')}>
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-body-sm',
              isActive ? 'bg-brand/10 text-brand' : 'text-fg-secondary hover:bg-surface-sunken',
            )
          }
        >
          {t(link.key)}
        </NavLink>
      ))}
    </nav>
  );
};
